export default "__VITE_ASSET__e9e7cda4__"